
(function () {

  const STORAGE_KEY = '2lane:garage';
  const MAX_RECENT  = 3;

  function str(key, fallback, vars) {
    return window.t ? window.t(key, fallback, vars) : fallback;
  }

  function catalogue() {
    return window.TwoLaneVehicles || null;
  }

  var vehiclesPromise = null;
  var vehiclesSettled = false;
  var fullCatalogue = null;

  function loadVehicles() {
    if (vehiclesPromise) return vehiclesPromise;
    var url = (window.themeAssets && window.themeAssets.vehicles) || '';
    if (!url) {
      vehiclesSettled = true;
      return Promise.resolve(null);
    }

    vehiclesPromise = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        if (!json) return null;
        var makesMap = json.makes || json;
        fullCatalogue = makesMap;
        if (window.TwoLaneFitment && window.TwoLaneFitment.offeredCatalogue) {
          makesMap = window.TwoLaneFitment.offeredCatalogue(makesMap);
        }
        window.TwoLaneVehicleYears = makesMap;
        window.TwoLaneVehicles = makesMap;
        window.TwoLaneVehicleFamilies = json.families || null;
        window.TwoLaneModelKeys = json.modelKeys || null;
        window.TwoLaneMakeCounts = json.counts || null;
        return makesMap;
      })
      .catch(function () { return null; })
      .then(function (makesMap) {
        vehiclesSettled = true;
        revalidate();
        return makesMap;
      });

    return vehiclesPromise;
  }

  function read() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) { /* private mode — fall through to an empty garage */ }
    return { active: null, recent: [] };
  }

  function write(state) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }
    catch (e) { /* nothing we can do; the picker still works in-session */ }
  }

  function stored() {
    try { return localStorage.getItem(STORAGE_KEY); }
    catch (e) { return null; }
  }

  let state = sanitize(read());

  function offeredMakesUsable() {
    const F = window.TwoLaneFitment;
    if (!F || !F.offeredMakes || !F.offeredCatalogue || !F.offeredMakes()) return true;
    if (!fullCatalogue || !Object.keys(fullCatalogue).length) return null;
    return Object.keys(F.offeredCatalogue(fullCatalogue)).length > 0;
  }

  function sanitize(s) {
    const F = window.TwoLaneFitment;
    s = s && typeof s === 'object' ? s : { active: null, recent: [] };
    if (!Array.isArray(s.recent)) s.recent = [];

    const usable = offeredMakesUsable();
    if (usable === false) return s;

    const offered = function (v) {
      return !!(v && v.make && (!F || !F.offeredMake || F.offeredMake(v.make)));
    };
    const ok = function (v) { return offered(v) && knownVehicle(v) !== false; };
    if (s.active && !ok(s.active)) s.active = null;
    s.recent = s.recent.filter(ok);
    const raw = stored();
    if (usable === true && raw !== null && JSON.stringify(s) !== raw) write(s);
    return s;
  }

  function knownVehicle(v) {
    const data = catalogue();
    if (!data || !v) return null;
    const F = window.TwoLaneFitment;
    const slug = F && F.slug ? F.slug : function (x) {
      return String(x || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    };
    const pick = function (map, wanted) {
      const want = slug(wanted);
      if (!want || !map || typeof map !== 'object') return null;
      return Object.keys(map).find(function (key) { return slug(key) === want; }) || null;
    };
    const make = pick(data, v.make);
    const model = make ? pick(data[make], v.model) : null;
    if (!model) return false;
    const years = (Array.isArray(data[make][model]) ? data[make][model] : []).map(String);
    if (years.indexOf(String(v.year)) === -1) return false;
    return { year: String(v.year), make: make, model: model };
  }

  function revalidate() {
    const before = JSON.stringify(state);
    state = sanitize(offeredMakesUsable() === false ? read() : state);
    if (JSON.stringify(state) !== before) broadcast();
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  const LEADING_CODE = /^((?:F[LX]|XL|XG|XR|VRSC|RA|RH)[A-Z0-9/-]*)\s+([^\d\s].*)$/;
  function modelLabel(name) {
    const m = LEADING_CODE.exec(name || '');
    return m ? m[2] + ' ' + m[1] : (name || '');
  }

  function label(vehicle) {
    if (!vehicle) return '';
    return [vehicle.year, vehicle.make, vehicle.model && modelLabel(vehicle.model)].filter(Boolean).join(' ');
  }

  function labelHtml(vehicle) {
    return escapeHtml(label(vehicle));
  }

  function sameVehicle(a, b) {
    return a && b && a.year === b.year && a.make === b.make && a.model === b.model;
  }

  function remember(vehicle) {
    state.active = vehicle;
    state.recent = [vehicle].concat(
      state.recent.filter(v => !sameVehicle(v, vehicle))
    ).slice(0, MAX_RECENT);
    write(state);
    broadcast();
  }

  function forget() {
    state.active = null;
    write(state);
    stripUrlVehicle();
    broadcast();
  }

  function stripUrlVehicle() {
    if (!window.history || !window.history.replaceState) return;
    const url = new URL(window.location.href);
    let touched = false;
    ['type', 'year', 'make', 'model'].forEach(key => {
      if (url.searchParams.has(key)) { url.searchParams.delete(key); touched = true; }
    });
    if (touched) window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  function broadcast() {
    document.dispatchEvent(new CustomEvent('garage:change', { detail: state }));
    renderChips();
  }

  function resultsUrl(vehicle) {
    const routes = window.routes || {};
    if (routes.collection_all_url || routes.collection_fitment_url) {
      const base = routes.collection_fitment_url || routes.collection_all_url;
      return base +
        '?year='  + encodeURIComponent(vehicle.year) +
        '&make='  + encodeURIComponent(vehicle.make) +
        '&model=' + encodeURIComponent(vehicle.model);
    }
    return 'shop.html' +
      '&year='  + encodeURIComponent(vehicle.year) +
      '&make='  + encodeURIComponent(vehicle.make) +
      '&model=' + encodeURIComponent(vehicle.model);
  }

  let drawer, scrim, form, lastFocused;

  function el(sel) { return drawer ? drawer.querySelector(sel) : null; }

  function open() {
    if (!drawer) return;
    lastFocused = document.activeElement;
    renderRecent();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    scrim.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('has-overlay');
    const close = el('[data-garage-close]');
    if (close) close.focus();
  }

  function close() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    scrim.classList.remove('is-active');
    document.body.style.overflow = '';
    document.body.classList.remove('has-overlay');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function option(value, text, disabled) {
    const o = document.createElement('option');
    o.value = value;
    o.textContent = text;
    if (disabled) o.disabled = true;
    return o;
  }

  function fill(select, placeholder, values) {
    select.innerHTML = '';
    select.appendChild(option('', placeholder));
    values.forEach(v => select.appendChild(option(v, v)));
    select.disabled = values.length === 0;
  }

  function updateSubmit() {
    const submit = el('[data-garage-submit]');
    if (!submit) return;
    submit.disabled = !(
      el('[data-garage-make]').value &&
      el('[data-garage-model]').value &&
      el('[data-garage-year]').value
    );
  }

  let selectsBound = false;
  let fetchCatalogue = function () {};

  const placeholderCache = {};

  function placeholderFor(select, key, english) {
    if (placeholderCache[key] === undefined) {
      const first = select && select.options && select.options[0];
      const rendered = first && !first.value ? String(first.textContent || '').trim() : '';
      placeholderCache[key] = rendered || str(key, english);
    }
    return placeholderCache[key];
  }

  function bindSelects() {
    const makeSel  = el('[data-garage-make]');
    const typeSel  = el('[data-garage-type]');
    const modelSel = el('[data-garage-model]');
    const yearSel  = el('[data-garage-year]');
    if (!makeSel || !typeSel) return;

    const makePh  = placeholderFor(makeSel,  'garage_make',  'Make');
    const modelPh = placeholderFor(modelSel, 'garage_model', 'Model');
    const yearPh  = placeholderFor(yearSel,  'garage_year',  'Year');

    const data = catalogue();

    if (!data) {
      fill(makeSel, str('garage_loading', 'Loading vehicles…'), []);
      makeSel.disabled = true;
      return;
    }

    makeSel.disabled = false;
    const currentMake = makeSel.value;

    const counts = window.TwoLaneMakeCounts || {};
    const ordered = Object.keys(data).sort(function (a, b) {
      return (counts[b] || 0) - (counts[a] || 0) || a.localeCompare(b);
    });
    fill(makeSel, makePh, ordered);
    Array.prototype.forEach.call(makeSel.options, function (o) {
      const n = counts[o.value];
      if (n) o.textContent = o.value + ' (' + n + ')';
    });
    if (currentMake && data[currentMake]) makeSel.value = currentMake;

    function lockSingleMake() {
      const real = Array.prototype.filter.call(makeSel.options, function (o) { return o.value; });
      if (real.length !== 1) {
        makeSel.classList.remove('is-fixed');
        return;
      }
      const only = real[0].value;
      real[0].textContent = only;
      if (makeSel.value !== only) makeSel.value = only;
      const typesLoaded = Array.prototype.some.call(typeSel.options, function (o) { return o.value; });
      if (!typesLoaded && selectsBound) makeSel.dispatchEvent(new Event('change'));
      makeSel.disabled = true;
      makeSel.classList.add('is-fixed');
      updateSubmit();
    }

    if (selectsBound) { lockSingleMake(); return; }   /* listeners below are registered once */
    selectsBound = true;

    const TYPE_ORDER = ['touring', 'softail', 'dyna', 'sportster', 'other'];
    const TYPE_EN = { touring: 'Touring', softail: 'Softail', dyna: 'Dyna', sportster: 'Sportster', other: 'Other / vintage' };
    const typePh = placeholderFor(typeSel, 'garage_type', 'Bike type');

    function fillLabelled(select, placeholder, pairs) {
      select.innerHTML = '';
      select.appendChild(option('', placeholder));
      pairs.forEach(function (p) { select.appendChild(option(p[0], p[1])); });
      select.disabled = pairs.length === 0;
    }

    function hasFamilies(make) {
      const F = window.TwoLaneFitment;
      const all = window.TwoLaneVehicleFamilies || {};
      return !!(F && Object.keys(all).some(function (k) { return F.slug(k) === F.slug(make); }));
    }

    function typeAt(make, model, year) {
      const F = window.TwoLaneFitment;
      const fam = F && F.familyOf ? F.familyOf({ make: make, model: model, year: String(year) }) : '';
      return fam || 'other';
    }

    function modelsOf(make) {
      const d = catalogue() || {};
      return d[make] || {};
    }

    makeSel.addEventListener('change', function () {
      const make = makeSel.value;
      const byModel = modelsOf(make);
      if (make && !hasFamilies(make)) {
        fillLabelled(typeSel, typePh, [['all', str('garage_all_models', 'All models')]]);
        typeSel.value = 'all';
        typeSel.dispatchEvent(new Event('change'));
        return;
      }
      const present = {};
      Object.keys(byModel).forEach(function (m) {
        (byModel[m] || []).forEach(function (y) { present[typeAt(make, m, y)] = true; });
      });
      fillLabelled(typeSel, typePh, TYPE_ORDER.filter(function (t) { return present[t]; })
        .map(function (t) { return [t, str('garage_type_' + t, TYPE_EN[t])]; }));
      fill(yearSel, yearPh, []);
      fill(modelSel, modelPh, []);
      updateSubmit();
    });

    typeSel.addEventListener('change', function () {
      const make = makeSel.value;
      const type = typeSel.value;
      const byModel = modelsOf(make);
      const years = {};
      Object.keys(byModel).forEach(function (m) {
        (byModel[m] || []).forEach(function (y) {
          if (type === 'all' || typeAt(make, m, y) === type) years[y] = true;
        });
      });
      fill(yearSel, yearPh, Object.keys(years).sort(function (a, b) { return Number(b) - Number(a); }));
      fill(modelSel, modelPh, []);
      updateSubmit();
    });

    yearSel.addEventListener('change', function () {
      const make = makeSel.value;
      const type = typeSel.value;
      const year = yearSel.value;
      const F = window.TwoLaneFitment;
      const byModel = modelsOf(make);
      const names = Object.keys(byModel).filter(function (m) {
        return (byModel[m] || []).map(String).indexOf(String(year)) !== -1 &&
          (type === 'all' || typeAt(make, m, year) === type);
      }).sort(function (a, b) { return b.length - a.length || a.localeCompare(b); });
      const kept = [];
      names.forEach(function (name) {
        const dup = F && F.sameModel && kept.some(function (k) {
          return F.sameModel(name, { make: make, model: k, year: year });
        });
        if (!dup) kept.push(name);
      });
      const sortKey = function (n) { return modelLabel(n).toLowerCase(); };
      kept.sort(function (a, b) { return sortKey(a).localeCompare(sortKey(b)); });
      fillLabelled(modelSel, modelPh, kept.map(function (n) { return [n, modelLabel(n)]; }));
      updateSubmit();
    });

    modelSel.addEventListener('change', updateSubmit);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const vehicle = {
        year:  yearSel.value,
        make:  makeSel.value,
        model: modelSel.value
      };
      remember(vehicle);
      window.location.href = resultsUrl(vehicle);
    });

    lockSingleMake();
  }

  function renderRecent() {
    const wrap = el('[data-garage-recent]');
    const list = el('[data-garage-recent-list]');
    if (!wrap || !list) return;

    if (!state.recent.length) {
      wrap.hidden = true;
      return;
    }

    wrap.hidden = false;
    const shopParts = escapeHtml(str('garage_shop_parts', 'Shop Parts'));
    list.innerHTML = state.recent.map((v, i) => `
      <li class="garage__vehicle${sameVehicle(v, state.active) ? ' is-active' : ''}">
        <div>
          <p class="garage__vehicle-name">${labelHtml(v)}</p>
          <a class="garage__vehicle-shop" href="${escapeHtml(resultsUrl(v))}" data-garage-pick="${i}">${shopParts}</a>
        </div>
        <button type="button" class="garage__vehicle-remove" data-garage-remove="${i}" aria-label="${escapeHtml(str('garage_remove', 'Remove __VEHICLE__', { VEHICLE: label(v) }))}">
          <svg width="13" height="13" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
            <line x1="1" y1="1" x2="17" y2="17" /><line x1="17" y1="1" x2="1" y2="17" />
          </svg>
        </button>
      </li>`).join('');
  }

  function renderChips() {
    document.querySelectorAll('[data-garage-label]').forEach(node => {
      node.textContent = state.active ? label(state.active) : '';
    });
    document.querySelectorAll('[data-garage-chip]').forEach(node => {
      node.hidden = !state.active;
    });
    document.querySelectorAll('[data-garage-empty]').forEach(node => {
      node.hidden = !!state.active;
    });
  }

  let fitIndex = null;
  let fitIndexPromise = null;
  let fitIndexSettled = false;

  function sharedFitIndex(url) {
    window.TwoLaneFitmentIndex = window.TwoLaneFitmentIndex ||
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    return window.TwoLaneFitmentIndex;
  }

  function loadFitIndex() {
    if (fitIndexPromise) return fitIndexPromise;
    const url = (window.themeAssets && window.themeAssets.fitment) || '';
    fitIndexPromise = (url ? sharedFitIndex(url) : Promise.resolve(null))
      .then(function (d) { fitIndex = d; return d; })
      .catch(function () { return null; })
      .then(function (d) { fitIndexSettled = true; return d; });
    return fitIndexPromise;
  }

  function cardFit(card, vehicle) {
    const F = window.TwoLaneFitment;
    if (!F) return 'unknown';
    const vocab = fitIndex ? { makes: fitIndex.makes, models: fitIndex.models } : null;
    const handle = card.dataset.handle;
    const rec = fitIndex && fitIndex.fit && handle ? fitIndex.fit[handle] : null;

    const models = (card.dataset.fitModels || '').split(',').filter(Boolean);
    if (models.length && card.dataset.fitYears) {
      const makes = (card.dataset.fitMakes || '').split(',').filter(Boolean);
      const year = parseInt(vehicle.year, 10);
      if (!isNaN(year) && !F.yearInSpec(card.dataset.fitYears, year)) return 'no';
      if (makes.length && makes.indexOf(F.slug(vehicle.make)) === -1) return 'no';
      if (models.indexOf(F.slug(vehicle.model)) === -1) return 'no';
      return rec ? F.verdict(rec, vehicle, vocab) : 'unknown';
    }

    if (rec) {
      const v = F.verdict(rec, vehicle, vocab);
      if (v === 'fits') return 'fits';
      if (v === 'no') {
        return F.tableMayPredate && F.tableMayPredate(rec, vehicle, vocab) ? 'unknown' : 'no';
      }
    }

    if (!F.familyVerdict) return 'unknown';
    const fams = (card.dataset.fitFamilies || '').split(',').filter(Boolean);
    const bikeFamily = F.familyOf(vehicle);
    if (!bikeFamily && fams.length && vehicle.year && window.TwoLaneVehicleFamilies) {
      return fams.length >= 4 ? 'unknown' : 'no';
    }
    return F.familyVerdict(fams, bikeFamily);
  }

  function vehicleFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const clean = (v) => (v || '').trim().slice(0, 60);
    const year = clean(params.get('year'));
    const rawMake = clean(params.get('make'));
    const model = clean(params.get('model'));
    if (!year || !rawMake || !model) return null;
    if (!/^\d{4}$/.test(year)) { stripUrlVehicle(); return null; }
    const F = window.TwoLaneFitment;
    const make = F && F.offeredMake ? F.offeredMake(rawMake) : rawMake;
    if (!make) { stripUrlVehicle(); return null; }
    return { year: year, make: make, model: model };
  }

  function resultsBanner(textHtml) {
    return `
      <div class="garage-banner">
        <p class="garage-banner__text">
          ${textHtml}
        </p>
        <div class="garage-banner__actions">
          <button type="button" class="garage-banner__change" data-garage-open>${escapeHtml(str('garage_change_vehicle', 'Change vehicle'))}</button>
          <button type="button" class="garage-banner__change" data-garage-clear>${escapeHtml(str('garage_show_all', 'Show all parts'))}</button>
        </div>
      </div>`;
  }

  const FIT_ICON = '<svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function setFitLabel(card, on, bike) {
    let tag = card.querySelector('[data-fit-label]');
    if (!on) { if (tag) tag.remove(); return; }
    if (!tag) {
      const info = card.querySelector('.product-card__info');
      if (!info) return;
      tag = document.createElement('p');
      tag.className = 'product-card__fit';
      tag.setAttribute('data-fit-label', '');
      info.insertBefore(tag, info.firstChild);
    }
    tag.innerHTML = FIT_ICON + '<span>' + escapeHtml(str('garage_card_listed', 'Listed for your bike')) + '</span>';
    tag.title = bike || '';
  }

  let bannerHadVehicle = false;
  function announce(host) {
    let live = host.parentNode && host.parentNode.querySelector('[data-garage-live]');
    if (!live && host.parentNode) {
      live = document.createElement('p');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('data-garage-live', '');
      host.parentNode.insertBefore(live, host.nextSibling);
    }
    if (!live) return;
    const text = host.querySelector('.garage-banner__text');
    live.textContent = '';
    setTimeout(function () { live.textContent = text ? text.textContent.replace(/\s+/g, ' ').trim() : ''; }, 50);
  }

  const LISTED_BATCH = 20;
  const LISTED_STEP = 40;
  let listed = null;

  function isResultsPage() {
    const p = new URLSearchParams(window.location.search);
    return p.has('year') && p.has('make') && p.has('model') &&
      !!document.querySelector('.template-collection [data-garage-results]');
  }

  function handleize(text) {
    return String(text || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function topBrandRank(vendor) {
    const raw = (window.themeSettings && window.themeSettings.topBrands) || '';
    const keys = raw.split(/[\r\n,]+/).map(handleize).filter(Boolean);
    const v = handleize(vendor);
    for (let i = 0; i < keys.length; i++) {
      if (v === keys[i] || v.indexOf(keys[i] + '-') === 0) return i;
    }
    return keys.length;
  }

  function listedFor(vehicle) {
    const F = window.TwoLaneFitment;
    const vocab = { makes: fitIndex.makes, models: fitIndex.models };
    const info = fitIndex.info || {};
    const names = fitIndex.types || [];
    const vendors = fitIndex.vendors || [];
    const kindOf = function (h) { return info[h] && info[h][0] >= 0 ? String(info[h][0]) : 'other'; };
    const brandRank = vendors.map(topBrandRank);
    const rankOf = function (h) { return info[h] && info[h][1] >= 0 ? brandRank[info[h][1]] : brandRank.length + 1; };
    const handles = Object.keys(fitIndex.fit).filter(function (h) {
      return F.verdict(fitIndex.fit[h], vehicle, vocab) === 'fits';
    });
    const counts = {};
    handles.forEach(function (h) { const k = kindOf(h); counts[k] = (counts[k] || 0) + 1; });
    const kinds = Object.keys(counts).filter(function (k) { return k !== 'other'; })
      .sort(function (a, b) { return counts[b] - counts[a] || names[a].localeCompare(names[b]); });
    if (counts.other) kinds.push('other');
    const order = {};
    kinds.forEach(function (k, i) { order[k] = i; });
    handles.sort(function (a, b) { return order[kindOf(a)] - order[kindOf(b)] || rankOf(a) - rankOf(b); });
    return { handles: handles, kinds: kinds, kindOf: kindOf, names: names };
  }

  function familyUrl(name) {
    const routes = window.routes || {};
    const base = routes.collection_fitment_url || routes.collection_all_url || '/collections/all';
    return base + '?filter.p.m.custom.bike_type=' + encodeURIComponent(name);
  }

  function listedKindName(k) {
    return k === 'other' ? str('garage_listed_other', 'Other parts') : listed.data.names[k];
  }

  function listedLive(kind) {
    const d = listed.data;
    return d.handles.filter(function (h) {
      return !listed.gone.has(h) && (kind === 'all' || d.kindOf(h) === kind);
    });
  }

  function paintListed() {
    const host = document.querySelector('[data-garage-results]');
    const root = listed.root;
    const vehicle = listed.vehicle;
    const count = listedLive('all').length;
    const bike = labelHtml(vehicle);
    const sentence = count
      ? str(
          count === 1 ? 'garage_listed_one_html' : 'garage_listed_other_html',
          '<strong>__COUNT__</strong> ' + (count === 1 ? 'part is' : 'parts are') +
            ' listed for your <strong>__VEHICLE__</strong>.',
          { COUNT: count, VEHICLE: bike }
        )
      : str(
          'garage_listed_none_html',
          'No part in the store lists your <strong>__VEHICLE__</strong> by model yet.',
          { VEHICLE: bike }
        );
    const famLink = listed.family
      ? ' <a class="garage-banner__inline" href="' + escapeHtml(familyUrl(listed.family)) + '">' +
          escapeHtml(str('garage_listed_family', 'See all __FAMILY__ parts', { FAMILY: listed.family })) + '</a>'
      : '';
    const html = resultsBanner(sentence + famLink);
    if (host && host.getAttribute('data-listed-html') !== html) {
      host.innerHTML = html;
      host.setAttribute('data-listed-html', html);
      announce(host);
    }

    root.querySelectorAll('[data-listed-kind]').forEach(function (chip) {
      const k = chip.getAttribute('data-listed-kind');
      const n = listedLive(k).length;
      chip.hidden = n === 0 && k !== 'all';
      chip.setAttribute('aria-pressed', String(k === listed.kind));
      const c = chip.querySelector('.garage-listed__chip-count');
      if (c) c.textContent = String(n);
    });

    const total = listedLive(listed.kind).length;
    const shown = listed.shown.size;
    const status = root.querySelector('[data-garage-listed-status]');
    const more = root.querySelector('[data-garage-listed-more]');
    if (status) {
      status.textContent = total ? str('garage_listed_showing', 'Showing __SHOWN__ of __TOTAL__', { SHOWN: shown, TOTAL: total }) : '';
    }
    if (more) more.hidden = shown >= total;
  }

  function loadListed(fromButton) {
    if (!listed || listed.busy) return;
    const next = listedLive(listed.kind).filter(function (h) { return !listed.shown.has(h); }).slice(0, LISTED_STEP);
    if (!next.length) { paintListed(); return; }
    const token = listed.token;
    const root = listed.root;
    const grid = root.querySelector('[data-garage-listed-grid]');
    const more = root.querySelector('[data-garage-listed-more]');
    const error = root.querySelector('[data-garage-listed-error]');
    const batches = [];
    for (let i = 0; i < next.length; i += LISTED_BATCH) batches.push(next.slice(i, i + LISTED_BATCH));
    const base = (window.routes && window.routes.search_url) || '/search';
    listed.busy = true;
    if (error) error.hidden = true;
    if (more) more.setAttribute('aria-busy', 'true');
    root.classList.add('is-loading');

    Promise.all(batches.map(function (batch) {
      return fetch(base + '?type=product&section_id=fitment-cards&q=' + encodeURIComponent(batch.join(' ')), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); });
    })).then(function (pages) {
      if (!listed || token !== listed.token) return;
      const bikeLabel = label(listed.vehicle);
      const added = [];
      pages.forEach(function (text, i) {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const got = {};
        doc.querySelectorAll('[data-fitment-cards] > .product-card').forEach(function (card) {
          const handle = card.getAttribute('data-product-handle');
          if (!handle || listed.shown.has(handle)) return;
          got[handle] = true;
          listed.shown.add(handle);
          const node = document.importNode(card, true);
          setFitLabel(node, true, bikeLabel);
          grid.appendChild(node);
          added.push(node);
        });
        batches[i].forEach(function (h) { if (!got[h]) listed.gone.add(h); });
      });
      paintListed();
      if (added.length) {
        document.dispatchEvent(new CustomEvent('theme:products-appended', {
          detail: { cards: added, source: 'garage' }
        }));
      }
      if (fromButton && added.length) {
        const link = added[0].querySelector('a[href]');
        if (link) link.focus();
      }
      return added.length;
    }).catch(function () {
      if (!listed || token !== listed.token) return;
      if (error) error.hidden = false;
    }).then(function (count) {
      if (!listed || token !== listed.token) return;
      listed.busy = false;
      if (more) more.removeAttribute('aria-busy');
      root.classList.remove('is-loading');
      if (count === 0) loadListed(fromButton);
    });
  }

  function renderListed(host, vehicle) {
    const key = [vehicle.year, vehicle.make, vehicle.model].join('|');
    document.documentElement.classList.add('is-fitment-results');
    if (listed && listed.key === key && listed.root.isConnected) return;

    const F = window.TwoLaneFitment;
    const fam = F.familyOf ? F.familyOf(vehicle) : '';
    const data = listedFor(vehicle);

    const title = document.querySelector('.collection__title');
    if (title) {
      if (!title.hasAttribute('data-garage-title')) title.setAttribute('data-garage-title', title.textContent);
      title.textContent = str('garage_results_title', 'Parts for your __VEHICLE__', { VEHICLE: label(vehicle) });
    }

    let root = document.querySelector('[data-garage-listed]');
    if (!root) {
      root = document.createElement('div');
      root.className = 'garage-listed';
      root.setAttribute('data-garage-listed', '');
      host.parentNode.insertBefore(root, host.nextSibling);
    }

    const chip = function (k, text, on) {
      return '<button type="button" class="garage-listed__chip" data-listed-kind="' + escapeHtml(k) + '" aria-pressed="' + on + '">' +
        escapeHtml(text) + ' <span class="garage-listed__chip-count"></span></button>';
    };
    listed = {
      key: key, vehicle: vehicle, data: data, root: root,
      family: fam && F.familyLabel ? F.familyLabel(fam) : '',
      kind: 'all', shown: new Set(), gone: new Set(), token: {}, busy: false
    };

    if (!data.handles.length) {
      root.innerHTML = listed.family
        ? '<div class="garage-listed__foot"><a class="collection-pagination__more" href="' + escapeHtml(familyUrl(listed.family)) + '">' +
            escapeHtml(str('garage_listed_family', 'See all __FAMILY__ parts', { FAMILY: listed.family })) + '</a></div>'
        : '';
      paintListed();
      bannerHadVehicle = true;
      return;
    }

    root.innerHTML =
      (data.kinds.length > 1
        ? '<div class="garage-listed__chips" role="group" aria-label="' + escapeHtml(str('garage_listed_filter', 'Filter by category')) + '">' +
            chip('all', str('garage_listed_all', 'All'), true) +
            data.kinds.map(function (k) { return chip(k, listedKindName(k), false); }).join('') +
          '</div>'
        : '') +
      '<div class="garage-listed__grid" data-garage-listed-grid></div>' +
      '<div class="garage-listed__foot">' +
        '<p class="garage-listed__status" data-garage-listed-status></p>' +
        '<button type="button" class="collection-pagination__more" data-garage-listed-more hidden>' +
          escapeHtml(str('garage_listed_more', 'Show more')) + '</button>' +
        '<p class="garage-listed__error" role="alert" data-garage-listed-error hidden>' +
          escapeHtml(str('garage_listed_error', "These parts didn't load.")) +
          ' <button type="button" class="garage-banner__inline" data-garage-listed-retry>' +
            escapeHtml(str('garage_listed_retry', 'Try again')) + '</button>' +
        '</p>' +
      '</div>';
    paintListed();
    bannerHadVehicle = true;
    loadListed(false);
  }

  function leaveResults() {
    document.documentElement.classList.remove('is-fitment-results');
    const root = document.querySelector('[data-garage-listed]');
    if (root) root.remove();
    const host = document.querySelector('[data-garage-results]');
    if (host) host.removeAttribute('data-listed-html');
    listed = null;
    const title = document.querySelector('.collection__title[data-garage-title]');
    if (title) {
      title.textContent = title.getAttribute('data-garage-title');
      title.removeAttribute('data-garage-title');
    }
  }

  document.addEventListener('click', function (e) {
    if (!listed || !e.target.closest) return;
    const chip = e.target.closest('[data-listed-kind]');
    if (chip) {
      const kind = chip.getAttribute('data-listed-kind');
      if (kind === listed.kind) return;
      listed.kind = kind;
      listed.token = {};
      listed.busy = false;
      listed.shown = new Set();
      listed.root.classList.remove('is-loading');
      listed.root.querySelector('[data-garage-listed-grid]').innerHTML = '';
      paintListed();
      loadListed(false);
      return;
    }
    if (e.target.closest('[data-garage-listed-more], [data-garage-listed-retry]')) loadListed(true);
  });

  function initCollection() {
    const host = document.querySelector('[data-garage-results]');
    if (!host) return;

    let vehicle = state.active;
    const fromUrl = vehicleFromUrl();
    if (fromUrl && !sameVehicle(fromUrl, state.active)) {
      const known = knownVehicle(fromUrl);
      if (known === null && !vehiclesSettled) {
        if (document.querySelector('.collection__grid .product-card')) loadFitIndex();
        loadVehicles().then(function () { initCollection(); });
        return;
      }
      if (known) {
        if (!sameVehicle(known, state.active)) {
          remember(known);
          return;
        }
        vehicle = known;
      } else if (known === false) {
        stripUrlVehicle();
      } else {
        vehicle = fromUrl;
      }
    }

    const cards = Array.prototype.slice.call(document.querySelectorAll('.collection__grid .product-card'));

    if (!vehicle) {
      leaveResults();
      host.innerHTML = `
        <div class="garage-banner garage-banner--empty">
          <p class="garage-banner__text">${escapeHtml(str('garage_prompt', 'Shopping for a specific bike? Tell us what you ride and we\'ll show parts listed for it.'))}</p>
          <div class="garage-banner__actions">
            <button type="button" class="garage-banner__change" data-garage-open>${escapeHtml(str('garage_title', 'Shop your ride'))}</button>
          </div>
        </div>`;
      cards.forEach(card => { card.hidden = false; setFitLabel(card, false); });
      if (bannerHadVehicle) announce(host);
      bannerHadVehicle = false;
      return;
    }

    if (isResultsPage()) {
      if (!fitIndexSettled || !vehiclesSettled) {
        if (!document.querySelector('[data-garage-listed]')) {
          host.innerHTML = resultsBanner(str(
            'garage_finding_html',
            'Finding the parts listed for your <strong>__VEHICLE__</strong>…',
            { VEHICLE: labelHtml(vehicle) }
          ));
        }
        Promise.all([loadVehicles(), loadFitIndex()]).then(function () { initCollection(); });
        return;
      }
      if (fitIndex && fitIndex.fit) { renderListed(host, vehicle); return; }
    }
    leaveResults();

    const needFamilies = !vehiclesSettled &&
      cards.some(function (c) { return c.dataset.fitFamilies; });
    const needIndex = !fitIndexSettled && cards.length > 0;
    if (needFamilies || needIndex) {
      host.innerHTML = resultsBanner(str(
        'garage_checking_html',
        'Checking which parts on this page are listed for your <strong>__VEHICLE__</strong>…',
        { VEHICLE: labelHtml(vehicle) }
      ));
      Promise.all([
        needFamilies ? loadVehicles() : null,
        needIndex ? loadFitIndex() : null
      ]).then(function () { initCollection(); });
      return;
    }

    let shown = 0;
    let family = 0;
    let unknown = 0;
    let rejected = 0;
    const bikeLabel = label(vehicle);
    cards.forEach(card => {
      const verdict = cardFit(card, vehicle);
      setFitLabel(card, verdict === 'fits', bikeLabel);
      card.hidden = verdict === 'no';
      if (verdict === 'fits') shown++;
      if (verdict === 'family') family++;
      if (verdict === 'unknown') unknown++;
      if (verdict === 'no') rejected++;
    });

    const visible = shown + family + unknown;

    const unknownNote = unknown
      ? str(
          unknown === 1 ? 'garage_results_unknown_one_html' : 'garage_results_unknown_other_html',
          ' <strong>__COUNT__</strong> ' + (unknown === 1 ? 'part has' : 'parts have') +
            ' no fitment listed for your bike, so ' + (unknown === 1 ? "it's" : "they're") +
            ' shown but not confirmed.',
          { COUNT: unknown }
        )
      : '';

    const hidden = rejected;
    const hiddenNote = hidden
      ? str(
          hidden === 1 ? 'garage_results_hidden_one_html' : 'garage_results_hidden_other_html',
          ' <strong>__COUNT__</strong> ' + (hidden === 1 ? 'part' : 'parts') +
            ' not listed for your bike ' + (hidden === 1 ? 'is' : 'are') + ' hidden.',
          { COUNT: hidden }
        )
      : '';

    const F1 = window.TwoLaneFitment;
    const familyName = F1 && F1.familyLabel ? escapeHtml(F1.familyLabel(F1.familyOf(vehicle))) : '';
    const familySentence = family && familyName
      ? str(
          family === 1 ? 'garage_results_family_one_html' : 'garage_results_family_other_html',
          'On this page: <strong>__SHOWN__</strong> of __TOTAL__ parts ' + (family === 1 ? 'is' : 'are') +
            ' listed for <strong>__FAMILY__</strong> models.',
          { SHOWN: family, TOTAL: visible, FAMILY: familyName }
        )
      : '';

    const familyTail = shown > 0 && family > 0 && familyName
      ? str(
          family === 1 ? 'garage_results_family_more_one_html' : 'garage_results_family_more_other_html',
          ' <strong>__COUNT__</strong> more ' + (family === 1 ? 'is' : 'are') +
            ' listed for <strong>__FAMILY__</strong> models.',
          { COUNT: family, FAMILY: familyName }
        )
      : '';

    const summary = shown === 0 && familySentence
      ? familySentence
      : shown === 0
      ? str(
          'garage_results_none_html',
          'No parts on this page are listed for your <strong>__VEHICLE__</strong>.',
          { VEHICLE: labelHtml(vehicle) }
        )
      : str(
          shown === 1 ? 'garage_results_one_html' : 'garage_results_other_html',
          'On this page: <strong>__SHOWN__</strong> of __TOTAL__ parts ' +
            (shown === 1 ? 'is' : 'are') +
            ' listed for your <strong>__VEHICLE__</strong>.',
          { SHOWN: shown, TOTAL: visible, VEHICLE: labelHtml(vehicle) }
        );

    const tail = `${familyTail}${unknownNote}`;
    host.innerHTML = resultsBanner(`${summary}${tail}${hiddenNote}`);
    announce(host);
    bannerHadVehicle = true;

  }

  document.addEventListener('garage:change', function () {
    if (document.querySelector('[data-garage-results]')) initCollection();
  });

  document.addEventListener('theme:products-appended', function (e) {
    if (e.detail && e.detail.source === 'garage') return;
    if (document.querySelector('[data-garage-results]')) initCollection();
  });

  function init() {
    drawer = document.getElementById('garage');
    scrim  = document.getElementById('garage-scrim');
    if (!drawer || !scrim) return;
    form = el('[data-garage-form]');
    if (!form) return;

    selectsBound = false;
    bindSelects();
    renderRecent();
    renderChips();
    initCollection();

    let vehiclesRequested = false;
    fetchCatalogue = function () {
      if (vehiclesRequested) return;
      vehiclesRequested = true;
      loadVehicles().then(function (real) {
        if (real) bindSelects();
      });
    };
    if (document.querySelector('[data-garage-results]')) fetchCatalogue();

    scrim.addEventListener('click', close);

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-garage-open]')) {
        e.preventDefault();
        fetchCatalogue();
        open();
        return;
      }
      if (e.target.closest('[data-garage-close]')) { close(); return; }
      if (e.target.closest('[data-garage-clear]')) {
        const banner = e.target.closest('[data-garage-results]');
        forget();
        const next = banner && banner.querySelector('[data-garage-open]');
        if (next) next.focus();
        return;
      }

      const remove = e.target.closest('[data-garage-remove]');
      if (remove) {
        const i = Number(remove.dataset.garageRemove);
        const removed = state.recent[i];
        state.recent.splice(i, 1);
        renderRecent();
        if (sameVehicle(removed, state.active)) { forget(); return; }
        write(state);
        broadcast();
        return;
      }

      const pick = e.target.closest('[data-garage-pick]');
      if (pick) remember(state.recent[Number(pick.dataset.garagePick)]);
    });

    if (window.TwoLaneA11y) {
      document.addEventListener('keydown', window.TwoLaneA11y.trap(drawer, function () {
        return drawer.classList.contains('is-open');
      }));
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.TwoLaneGarage = {
    open: open,
    close: close,
    get active() { return state.active; },
    label: label,
    set: remember,
    clear: forget
  };

})();
